module.exports = __webpack_public_path__ + "img/hontai_Grand Bleu.9c5c28db.png";